import React from 'react';
import style from './rectangle.scss';
import PropTypes from 'prop-types';

export const Rectangle = ({ children, className = '', ...rest }) => {
  const { dataHook, ...rectangleProps } = rest;
  return (
    <div
      {...rectangleProps}
      data-hook={dataHook}
      className={`${style.rectangle} ${className}`}
    >
      {children}
    </div>
  );
};

Rectangle.propTypes = {
  dataHook: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
};
